var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.className,attrs:{"disabled":_vm.disabled || _vm.isLoading,"type":_vm.type},on:{"click":_vm.click}},[(_vm.isLoading)?_c('SpinnerIcon',{staticClass:"infinite-rotation"}):_vm._e(),(_vm.hasAction)?_c('span',{staticClass:"sbtn__loader"},[_vm._v("Loading...")]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }